export default "__VITE_ASSET__kLYt2Uk___"